<template>
  <div class="hornet-menu" :style="'width:'+width +'px;'">
    <div class="logo-wrap">
      <div class="logo">
        <img v-show="openMenu" :src="logo" alt="">
        <div v-show="!openMenu" :style="'background-image:url('+ logo +');width:40px;height:29px;margin:0 auto;'"></div>
      </div>
    </div>
    <div class="menu-wrap">
      <div class="menu-child-wrap" id="menu-child-wrap" :style="'width:'+ (width + 40) +'px;'">
        <Menu ref="cmenu" :width="width" :list="menuList" :isMin="!openMenu" @opemMenu="opemMenu" />
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "@/components/menu";
// import { setStorageCurrentMenu } from "@/utils/store";
import { mapState } from "vuex";
import { insupaiImg } from '@/utils'
export default {
  components: {
    Menu
  },
  props: {
    width: {
      type: Number,
      default: () => 0
    },
    openMenu: {
      type: Boolean,
      default: () => true
    }
  },
  data() {
    return {
      logo: insupaiImg('insupai-logo.png'),
      showMenu: true
    };
  },
  computed: {
    ...mapState({
      currentMenu:state => state.app.currentMenu,
      menuList: state => state.app.menuList
    })
  },
  methods: {
    openGroup(group, isReset) {
      this.$refs.cmenu.handleGroup(group, isReset)
    },
    // changeMenu(menu) {
    //   if (menu.id && (menu.id != this.currentMenu.id || this.$route.path != menu.path )) {
    //     if (this.$route.path != menu.path) {
    //       this.$router.push(menu.path)
    //     }
    //   }
    // },
    opemMenu() {
      this.$emit('opemMenu')
    }
  }
};
</script>

<style lang="scss">
.hornet-menu {
  overflow: hidden;
  position: fixed;
  transition: all .2s;
  z-index: 5;
  top: 0;
  left: 0;
  bottom: 0;
  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);
  background: #191a23;
  display: flex;
  flex-direction: column;
  .logo-wrap {
    overflow: hidden;
    height: 64px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    white-space: nowrap;
    .logo {
      width: 121px;
      height: 29px;
      text-align: center;
      img {
        width: 100%;
        height: 100%;
      }
      .text {
        width: 44px;
        height: 44px;
      }
    }
  }
  .menu-wrap {
    height: 100%;
    flex: 1;
    overflow-x: hidden;
    .menu-child-wrap {

      height: 100%;
      overflow-y: auto;
    }
  }
}
</style>